// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/ic-delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ic-delete-red.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.PageLayout {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 72px;
  min-height: 72px;
}
.PageLayout .page-container {
  padding: 0 40px;
}
.PageLayout .page-container.active-side-menu {
  padding: 0 40px;
}
.PageLayout .page-container .cards-container {
  margin-top: 10px;
}
.PageLayout .card-options-container {
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: 0;
  padding: 0 30px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  border-top: 1px solid #E1E1E9;
  border-bottom: 1px solid #E1E1E9;
}
.PageLayout .card-options-container .option {
  display: flex;
  align-items: center;
}
.PageLayout .card-options-container .option.view-options {
  margin-right: 65px;
}
.PageLayout .card-options-container .option .dropdown-container {
  font-size: 12px;
}
.PageLayout .card-options-container .option .option-title {
  margin-right: 8px;
  font-size: 12px;
  text-transform: uppercase;
  white-space: nowrap;
  user-select: none;
  color: #959AAD;
}
.PageLayout .card-options-container .option .dropdown-icon {
  margin-top: -4px;
}
.PageLayout .card-options-container .sorting-options.option {
  margin-right: 30px;
}
.PageLayout .card-options-container .sorting-options .sorted-by {
  color: #333F48;
  font-size: 13px;
  position: relative;
  bottom: -2px;
}
.PageLayout .card-options-container .sorting-options .sorted-by:hover {
  cursor: pointer;
}
.PageLayout .card-options-container .search-options {
  flex-grow: 1;
}
.PageLayout .card-options-container .search-options.option .list-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  padding-left: 35px;
  border: 1px solid #E1E1E9;
  border-radius: 4px;
}
.PageLayout .card-options-container .search-options.option .list-search:focus {
  outline: 0;
}
.PageLayout .card-options-container .search-options.option .list-search::placeholder {
  color: #959AAD;
  font-size: 12px;
  font-weight: 300;
}
.PageLayout .card-options-container .search-options.option .list-search:-ms-input-placeholder {
  color: #959AAD;
  font-size: 12px;
  font-weight: 300;
}
.PageLayout .card-options-container .search-options .search-by {
  color: #333F48;
  font-size: 13px;
  position: relative;
  bottom: -2px;
}
.PageLayout .card-options-container .search-options .search-by:hover {
  cursor: pointer;
}
.PageLayout .card-options-container .toggle-option {
  margin-left: 16px;
}
.PageLayout .card-options-container .toggle-option .toggle-container {
  display: flex;
  align-items: left;
}
.PageLayout .card-options-container .toggle-option .toggle-container .switch__checkbox {
  border-radius: 25px;
  background-color: #E1E1E9;
  cursor: pointer;
  height: 26px;
  position: relative;
  transition: all 300ms ease;
  width: 52px;
}
.PageLayout .card-options-container .toggle-option .toggle-container .switch__checkbox::after {
  height: 24px;
  width: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 4px 4px;
}
.PageLayout .card-options-container .toggle-option .toggle-container .switch__input:checked + .switch__checkbox::after {
  left: 27px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: 4px 4px;
}
.PageLayout .card-options-container .toggle-option .toggle-container .switch__input:checked + .switch__checkbox {
  background-color: #CF0838;
}
.PageLayout .card-options-container .toggle-option .option-title {
  letter-spacing: 0.8px;
}
.PageLayout .card-options-container .label-dropdown {
  display: flex;
  align-items: center;
  color: #333F48;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
  white-space: nowrap;
}
.PageLayout .card-options-container .label-dropdown:hover {
  cursor: pointer;
}
.PageLayout .card-options-container .toggle-view-container {
  display: flex;
  align-items: center;
  margin-left: 16px;
}
.PageLayout .menu-container {
  white-space: nowrap;
}
.PageLayout .search-container {
  flex-grow: 1;
  width: 100%;
  margin-left: 10px;
}
.PageLayout.layout-purple .card-options-container {
  background: #222732;
  border: none;
}
.PageLayout.layout-purple .card-options-container .option .option-title {
  color: #333F48;
}
.PageLayout.layout-purple .card-options-container .label-dropdown {
  color: #FFFFFF;
}
.PageLayout.layout-purple .card-options-container .search-options.option .list-search {
  background: #333F48;
  color: #FFFFFF;
  border: none;
}
.PageLayout.layout-purple .card-options-container .search-options.option .list-search::placeholder {
  color: #222732;
}
.PageLayout.align-right .card-options-container {
  padding-right: 0;
}
.PageLayout.align-right .card-options-container .option.search-options {
  margin-right: 30px;
}

.PageLayoutPaper {
  background: #222732 !important;
}
.PageLayoutPaper .menu-item {
  color: #FFFFFF;
  font-family: "Lato", sans-serif;
  font-size: 12px;
  padding: 5px 20px;
}
.PageLayoutPaper .menu-item:hover {
  background: #333F48;
}
.PageLayoutPaper .menu-item.disabled:hover {
  background-color: #222732;
  cursor: default;
}

.PageLayoutDropdown {
  z-index: 1301 !important;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/vibeguide/src/components/PageLayout/PageLayout.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAwFF;AAtFE;EACE,eAAA;AAwFJ;AAtFI;EACE,eAAA;AAwFN;AArFI;EACE,gBAAA;AAuFN;AAnFE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,yBDLI;ECMJ,sBAAA;EACA,6BAAA;EACA,gCAAA;AAqFJ;AAnFI;EACE,aAAA;EACA,mBAAA;AAqFN;AAnFM;EACE,kBAAA;AAqFR;AAlFM;EACE,eAAA;AAoFR;AAjFM;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cDrCE;ACwHV;AAhFM;EACE,gBAAA;AAkFR;AA5EM;EACE,kBAAA;AA8ER;AA3EM;EACE,cD5DE;EC6DF,eAAA;EACA,kBAAA;EACA,YAAA;AA6ER;AA3EQ;EACE,eAAA;AA6EV;AAxEI;EACE,YAAA;AA0EN;AAtEQ;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAwEV;AAtEU;EACE,UAAA;AAwEZ;AArEU;EACE,cDjFF;ECkFE,eAAA;EACA,gBAAA;AAuEZ;AApEU;EACE,cDvFF;ECwFE,eAAA;EACA,gBAAA;AAsEZ;AAjEM;EACE,cDvGE;ECwGF,eAAA;EACA,kBAAA;EACA,YAAA;AAmER;AAjEQ;EACE,eAAA;AAmEV;AA9DI;EACE,iBAAA;AAgEN;AA9DM;EACE,aAAA;EACA,iBAAA;AAgER;AA9DQ;EACE,mBAAA;EACA,yBDpHG;ECqHH,eAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;AAgEV;AA7DQ;EACE,YAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,4BAAA;AA+DV;AA5DQ;EACE,UAAA;EACA,yDAAA;EACA,4BAAA;EACA,4BAAA;AA8DV;AA3DQ;EACE,yBDrIF;ACkMR;AAzDM;EACE,qBAAA;AA2DR;AAvDI;EACE,aAAA;EACA,mBAAA;EACA,cD/JI;ECgKJ,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAyDN;AAvDM;EACE,eAAA;AAyDR;AArDI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAuDN;AAnDE;EACE,mBAAA;AAqDJ;AAlDE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAoDJ;AA5CI;EACE,mBDhMM;ECiMN,YAAA;AA8CN;AA1CQ;EACE,cDvMA;ACmPV;AAxCM;EACE,cD3LA;ACqOR;AAnCU;EACE,mBDpNF;ECqNE,cDpMJ;ECqMI,YAAA;AAqCZ;AAnCY;EACE,cDxNF;AC6PZ;AA1BI;EACE,gBAAA;AA4BN;AAxBQ;EACE,kBAAA;AA0BV;;AAnBA;EACE,8BAAA;AAsBF;AApBE;EACE,cDpOI;ECqOJ,+BAAA;EACA,eAAA;EACA,iBAAA;AAsBJ;AApBI;EACE,mBD3PI;ACiRV;AAnBI;EACE,yBD9PM;EC+PN,eAAA;AAqBN;;AAhBA;EACE,wBAAA;AAmBF","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxPurple16: rgba($boxPurple, 0.16);\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n  boxPurple16: $boxPurple16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '../../sass/color.scss' as color;\n\n.PageLayout {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 72px;\n  min-height: 72px;\n\n  .page-container {\n    padding: 0 40px;\n\n    &.active-side-menu {\n      padding: 0 40px;\n    }\n\n    .cards-container {\n      margin-top: 10px;\n    }\n  }\n\n  .card-options-container {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    margin-left: 0;\n    padding: 0 30px;\n    background-color: color.$white;\n    box-sizing: border-box;\n    border-top: 1px solid color.$whiteSmoke;\n    border-bottom: 1px solid color.$whiteSmoke;\n\n    .option {\n      display: flex;\n      align-items: center;\n\n      &.view-options {\n        margin-right: 65px;\n      }\n\n      .dropdown-container {\n        font-size: 12px;\n      }\n\n      .option-title {\n        margin-right: 8px;\n        font-size: 12px;\n        text-transform: uppercase;\n        white-space: nowrap;\n        user-select: none;\n        color: color.$manatee;\n      }\n\n      .dropdown-icon {\n        margin-top: -4px;\n      }\n    }\n\n    .sorting-options {\n\n      &.option {\n        margin-right: 30px;\n      }\n\n      .sorted-by {\n        color: color.$primary;\n        font-size: 13px;\n        position: relative;\n        bottom: -2px;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .search-options {\n      flex-grow: 1;\n\n      &.option {\n\n        .list-search {\n          box-sizing: border-box;\n          width: 100%;\n          padding: 10px;\n          padding-left: 35px;\n          border: 1px solid color.$whiteSmoke;\n          border-radius: 4px;\n\n          &:focus {\n            outline: 0;\n          }\n\n          &::placeholder {\n            color: color.$manatee;\n            font-size: 12px;\n            font-weight: 300;\n          }\n\n          &:-ms-input-placeholder {\n            color: color.$manatee;\n            font-size: 12px;\n            font-weight: 300;\n          }\n        }\n      }\n\n      .search-by {\n        color: color.$primary;\n        font-size: 13px;\n        position: relative;\n        bottom: -2px;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .toggle-option {\n      margin-left: 16px;\n\n      .toggle-container {\n        display: flex;\n        align-items: left;\n\n        .switch__checkbox {\n          border-radius: 25px;\n          background-color: color.$whiteSmoke;\n          cursor: pointer;\n          height: 26px;\n          position: relative;\n          transition: all 300ms ease;\n          width: 52px;\n        }\n\n        .switch__checkbox::after {\n          height: 24px;\n          width: 24px;\n          background-image: url('../../assets/ic-delete.png');\n          background-repeat: no-repeat;\n          background-position: 4px 4px;\n        }\n\n        .switch__input:checked + .switch__checkbox::after {\n          left: 27px;\n          background-image: url('../../assets/ic-delete-red.png');\n          background-repeat: no-repeat;\n          background-position: 4px 4px;\n        }\n\n        .switch__input:checked + .switch__checkbox {\n          background-color: color.$error;\n        }\n      }\n\n      .option-title {\n        letter-spacing: 0.8px;\n      }\n    }\n\n    .label-dropdown {\n      display: flex;\n      align-items: center;\n      color: color.$primary;\n      font-size: 12px;\n      font-weight: 900;\n      text-transform: uppercase;\n      white-space: nowrap;\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n\n    .toggle-view-container {\n      display: flex;\n      align-items: center;\n      margin-left: 16px;\n    }\n  }\n\n  .menu-container {\n    white-space: nowrap;\n  }\n\n  .search-container {\n    flex-grow: 1;\n    width: 100%;\n    margin-left: 10px;\n  }\n\n  // &.layout-white {\n\n  // }\n  &.layout-purple {\n\n    .card-options-container {\n      background: color.$secondary;\n      border: none;\n\n      .option {\n\n        .option-title {\n          color: color.$primary;\n        }\n      }\n\n      .label-dropdown {\n        color: color.$white;\n      }\n\n      .search-options {\n\n        &.option {\n\n          .list-search {\n            background: color.$primary;\n            color: color.$white;\n            border: none;\n\n            &::placeholder {\n              color: color.$secondary;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Align the page layout to the right\n  &.align-right {\n\n    .card-options-container {\n      padding-right: 0;\n\n      .option {\n\n        &.search-options {\n          margin-right: 30px;\n        }\n      }\n    }\n  }\n}\n\n.PageLayoutPaper {\n  background: color.$secondary !important;\n\n  .menu-item {\n    color: color.$white;\n    font-family: 'Lato', sans-serif;\n    font-size: 12px;\n    padding: 5px 20px;\n\n    &:hover {\n      background: color.$primary;\n    }\n\n    &.disabled:hover {\n      background-color: color.$secondary;\n      cursor: default;\n    }\n  }\n}\n\n.PageLayoutDropdown {\n  z-index: 1301 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxPurple16 = `rgba(109, 109, 181, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
